module.exports = __webpack_public_path__ + "img/icon-other.1d1cd662.png";